/* eslint-disable */
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import { geti18n } from '../../utils';
import { getBrandFromState } from '../../redux/selectors';
import {
  DealerCardWrapperStyled,
  DealerCardNameStyled,
  DealerCardAddressWrapperStyled,
  DealerCardAddressLineStyled,
  DealerCardCityStateZipWrapperStyled,
  DealerCardCityStyled,
  DealerCardStateCodeStyled,
  DealerCardPostalCodeStyled,
  DealerCardMilesAwayStyled,
  DealerCardSelectButtonWrapperStyled,
  DealerDistanceSelectWrapperStyled,
  DealerInfoWrapperStyled,
  StyledDealerPhoneNum
} from './styles';

class DealerCard extends Component {
  static propTypes = {
    distanceFrom: PropTypes.string,
    selectButton: PropTypes.string,
    milesAbbrev: PropTypes.string,
    currentDealer: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired,
    brandName: PropTypes.string.isRequired
  };
  static defaultProps = {
    distanceFrom: geti18n('leadsFormContent.dealerCard.distanceFrom'),
    selectButton: geti18n('leadsFormContent.dealerCard.selectButton'),
    milesAbbrev: geti18n('leadsFormContent.dealerCard.milesAbbrev')
  };

  render() {
    const { data } = this.props;

    /* eslint-disable */
    const renderDealerName = (dealer) => {
      return dealer.dealerName ? <DealerCardNameStyled>{dealer.dealerName}</DealerCardNameStyled> : null;
    };
    /* eslint-enable */

    const renderDealerAddress = (dealer) => {
      return dealer.dealerAddressLine1 ? (
        <DealerCardAddressWrapperStyled>
          <DealerCardAddressLineStyled>{dealer.dealerAddressLine1}</DealerCardAddressLineStyled>
          {dealer.dealerAddressLine2 ? (
            <DealerCardAddressLineStyled>{dealer.dealerAddressLine2}</DealerCardAddressLineStyled>
          ) : null}
        </DealerCardAddressWrapperStyled>
      ) : null;
    };

    const renderDealerCity = (dealer) => {
      return dealer.dealerCityName ? <DealerCardCityStyled>{dealer.dealerCityName}</DealerCardCityStyled> : null;
    };

    const renderDealerStateCode = (dealer) => {
      return dealer.dealerStateCode ? (
        <DealerCardStateCodeStyled>{dealer.dealerStateCode}</DealerCardStateCodeStyled>
      ) : null;
    };

    const renderDealerPostalCode = (dealer) => {
      return dealer.dealerZip ? <DealerCardPostalCodeStyled>{dealer.dealerZip}</DealerCardPostalCodeStyled> : null;
    };

    const renderDealerMilesAway = (dealer) => {
      const { distanceFrom, milesAbbrev } = this.props;
      const roundedNumber = dealer.dealerDistance ? Math.round(dealer.dealerDistance * 10) / 10 : null;
      return roundedNumber ? (
        <DealerCardMilesAwayStyled>
          <span>{roundedNumber} {milesAbbrev}</span>
          <span>
            {distanceFrom} {dealer.dealerZip}
          </span>
        </DealerCardMilesAwayStyled>
      ) : null;
    };

    const renderDealerSelectButton = (dealer) => {
      const { currentDealer, selectButton, brandName } = this.props;
      const buttonWidth = brandName === 'nissan' ? '140px' : 'auto';
      return dealer.dealerId ? (
        <DealerCardSelectButtonWrapperStyled>
          <Button
            text={selectButton}
            width={buttonWidth}
            float="right"
            onClick={() => (dealer.dealerId ? currentDealer(dealer) : null)}
          />
        </DealerCardSelectButtonWrapperStyled>
      ) : null;
    };

    const renderDealerPhoneNum = (dealer) => {
      return (
        <StyledDealerPhoneNum>
          {dealer.dealerPhoneNumber}
        </StyledDealerPhoneNum>
      )
    }

    const renderDealerCard = () => {
      return data.map(dealer => (
        <DealerCardWrapperStyled key={dealer.dealerId}>
          <DealerInfoWrapperStyled>
            {renderDealerName(dealer)}
            {renderDealerPhoneNum(dealer)}
            {renderDealerAddress(dealer)}
            {/* {renderDealerMilesAway(dealer)} */}
            <DealerCardCityStateZipWrapperStyled>
              {renderDealerCity(dealer)}
              {renderDealerStateCode(dealer)}
              {renderDealerPostalCode(dealer)}
            </DealerCardCityStateZipWrapperStyled>
          </DealerInfoWrapperStyled>
          <DealerDistanceSelectWrapperStyled>
            {renderDealerSelectButton(dealer)}
          </DealerDistanceSelectWrapperStyled>
        </DealerCardWrapperStyled>
      ));
    };
    return (
      <div>
        {renderDealerCard()}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  brandName: getBrandFromState(state)
});

export default (connect(mapStateToProps)(DealerCard));

/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/components/DealerCard/index.js
 **/